import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2, KeyRound, CheckCircle2, AlertCircle } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function Activar() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [inv, setInv] = useState(null);
  const [error, setError] = useState("");
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [listo, setListo] = useState(false);

  useEffect(() => {
    if (!token) { setError("Falta el token de invitación."); return; }
    api.get(`/auth/invitacion/${token}`).then((r) => setInv(r.data)).catch((e) => setError(formatApiError(e)));
  }, [token]);

  async function onSubmit(e) {
    e.preventDefault();
    if (p1.length < 8) { setError("La contraseña debe tener al menos 8 caracteres."); return; }
    if (p1 !== p2) { setError("Las contraseñas no coinciden."); return; }
    setError(""); setGuardando(true);
    try { await api.post("/auth/invitacion/establecer", { token, password: p1 }); setListo(true); setTimeout(() => navigate("/login"), 2500); } catch (err) { setError(formatApiError(err)); } finally { setGuardando(false); }
  }

  return (
    <div className="min-h-screen bg-brand-ink dark-grid flex items-center justify-center p-6" data-testid="activar-page">
      <div className="w-full max-w-md animate-fade-up">
        <div className="bg-white rounded-2xl px-3 py-2 inline-block mb-6"><img src="/rubipos-logo.png" alt="RubiPOS" className="h-7 w-auto" /></div>
        <div className="rounded-3xl bg-white p-7 shadow-2xl">
          {listo ? (
            <div className="text-center py-6" data-testid="activar-exito"><CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto mb-3" /><h1 className="font-display text-xl font-extrabold text-brand-ink">¡Contraseña creada!</h1><p className="text-sm text-brand-muted mt-1">Tu cuenta ya está activa. Te llevamos al inicio de sesión…</p><Link to="/login" className="btn-amber h-11 px-6 mt-5 inline-flex" data-testid="activar-ir-login">Entrar a RubiPOS</Link></div>
          ) : !inv && !error ? (
            <div className="flex items-center gap-2 text-sm text-brand-muted py-6 justify-center" data-testid="activar-cargando"><Loader2 className="w-4 h-4 animate-spin" /> Validando invitación…</div>
          ) : !inv ? (
            <div className="text-center py-6" data-testid="activar-invalida"><AlertCircle className="w-12 h-12 text-rose-500 mx-auto mb-3" /><h1 className="font-display text-xl font-extrabold text-brand-ink">Invitación no válida</h1><p className="text-sm text-brand-muted mt-1">{error}</p><Link to="/login" className="btn-soft h-10 px-5 mt-5 inline-flex text-sm">Ir al inicio de sesión</Link></div>
          ) : (
            <form onSubmit={onSubmit} data-testid="activar-form">
              <div className="eyebrow mb-1">Bienvenida a RubiPOS</div>
              <h1 className="font-display text-2xl font-extrabold tracking-tight text-brand-ink">Hola, {inv.nombre.split(" ")[0]}</h1>
              <p className="text-sm text-brand-muted mt-1">Crea la contraseña para <strong>{inv.email}</strong>{inv.sucursal && <> · {inv.sucursal}</>}.</p>
              <label className="block mt-5 text-xs font-semibold text-brand-slate">Nueva contraseña</label>
              <input data-testid="activar-password-input" type="password" value={p1} onChange={(e) => setP1(e.target.value)} className="field w-full mt-1" minLength={8} required autoFocus />
              <label className="block mt-3 text-xs font-semibold text-brand-slate">Repite la contraseña</label>
              <input data-testid="activar-password2-input" type="password" value={p2} onChange={(e) => setP2(e.target.value)} className="field w-full mt-1" minLength={8} required />
              {error && <div data-testid="activar-error" className="mt-3 text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-xl px-4 py-2.5">{error}</div>}
              <button data-testid="activar-submit" type="submit" disabled={guardando} className="btn-amber w-full h-12 mt-5">{guardando ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />} Crear contraseña y activar</button>
              <p className="text-[11px] text-brand-muted mt-3 text-center">Mínimo 8 caracteres. Este enlace es personal y vence a los 7 días.</p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
